import { Suspense } from 'react';
import { createFileRoute, notFound } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { LeaveApplicationDetailPage } from '@/features/leaveApplications/pages/LeaveApplicationDetailPage';
import { parsePositiveIdParams } from '@/utils/routeParams';

export const Route = createFileRoute('/_auth/hr-form/leave-applications/$applicationId')({
  parseParams: (rawParams) => {
    const params = parsePositiveIdParams(rawParams);
    if (params === null) throw notFound();
    return params;
  },
  component: function LeaveApplicationDetailRoute() {
    const { applicationId } = Route.useParams();
    return (
      <ErrorBoundary moduleName="Leave Application Details">
        <Suspense fallback={<PageLoader />}>
          <LeaveApplicationDetailPage applicationId={applicationId} />
        </Suspense>
      </ErrorBoundary>
    );
  },
});
